module.exports = __webpack_public_path__ + "img/024-feedback.727f3144.svg";